module.exports = __webpack_public_path__ + "img/button.8b673641.png";